module.exports = __webpack_public_path__ + "Lato-LightItalic.7be5435e82c853b13cae.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-LightItalic.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-LightItalic.eot
// module chunks = styles